import { initialState } from "./state"

import { mutations } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  updateUuid: (state, payload) => (state.uuid = payload),
  updateIsEditing: (state, payload) => {
    state.isEditing = payload

    if (payload) {
      state.steps = ["Conta", "Acessos", "Hierarquia", "Liderança", "Restrição"]
      state.stepsNamesRoutes = [
        "",
        "user-account",
        "user-access",
        "user-hierarchy",
        "user-leadership",
        "user-restriction"
      ]
    } else {
      state.steps = ["Conta", "Acessos", "Hierarquia", "Liderança"]
      state.stepsNamesRoutes = [
        "",
        "user-account",
        "user-access",
        "user-hierarchy",
        "user-leadership"
      ]
    }
  },
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateUsername: (state, payload) => (state.username = payload),
  updateName: (state, payload) => (state.name = payload),
  updateCpf: (state, payload) => (state.cpf = payload),
  updateBirthdate: (state, payload) => (state.birthdate = payload),
  updateEmail: (state, payload) => (state.email = payload),
  updateRole: (state, payload) => (state.role = payload),
  updateProviders: (state, payload) => (state.providers = payload),
  updatePos: (state, payload) => (state.pos = payload),
  updateFavoritePos: (state, payload) => (state.favoritePos = payload),
  updateChains: (state, payload) => (state.chains = payload),
  updateAllChains: (state, payload) => (state.all_chains = payload),
  updateLeaders: (state, payload) => (state.leaders = payload),
  updateLed: (state, payload) => (state.led = payload),
  updateSuperior: (state, payload) => (state.superior = payload),
  updateHasHierarchy: (state, payload) => (state.hasHierarchy = payload),
  updateSuperiorChain: (state, payload) => (state.superiorChain = payload),
  updateGender: (state, payload) => (state.gender = payload),
  updatePhoto: (state, payload) => (state.photo = payload),
  updateAddress: (state, address) => (state.address = address),
  updateIsAdmin: (state, payload) => (state.isAdmin = payload),
  updateActive: (state, payload) => (state.active = payload),
  updateLoading: (state, payload) => (state.loading = payload),
  updateSteps: (state, payload) => (state.steps = payload),
  updateStepsNamesRoutes: (state, payload) =>
    (state.stepsNamesRoutes = payload),
  updateChainsAccess: (state, payload) => (state.chainsAccess = payload),
  updateSelectedChains: (state, payload) => (state.selectedChains = payload),
  updateSelectedPos: (state, payload) => (state.selectedPos = payload),
  updatePosOptions: (state, payload) => (state.posOptions = payload),
  updateChainsOptions: (state, payload) => (state.chainsOptions = payload),
  updateRolesOptions: (state, payload) => (state.rolesOptions = payload),
  setRoleCategory: (state, payload) => (state.roleCategory = payload),
  updatePhone: (state, payload) => (state.phone = payload),
  resetUser: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },

  ...mutations
}
